const appConfig = {
  apiPrefix: `${process.env.REACT_APP_BACKEND_BASE_URL}/api`,
  authenticatedEntryPath: "/dashboard",
  unAuthenticatedEntryPath: "/sign-in",
  tourPath: "/app/account/kyc-form",
  enableMock: false,
};

export default appConfig
